import React from 'react';

export const FieldTagsSection = ({ title, description, fields = [] }) => {
  if (!fields || fields.length === 0) return null;

  const tagColors = [
    { bg: '#E8F4F4', hoverBg: '#D0EAEA', text: '#2D6A6A' },
    { bg: '#EEF2F7', hoverBg: '#DDE5F0', text: '#1E3A5F' },
    { bg: '#FDF6E9', hoverBg: '#FAECD3', text: '#8B6914' },
    { bg: '#F0F4EF', hoverBg: '#E0E9DD', text: '#4A6B5D' },
    { bg: '#F5F0F0', hoverBg: '#EAE2E2', text: '#6B5A5A' },
    { bg: '#F0EEF5', hoverBg: '#E2DEF0', text: '#5A4A6B' },
    { bg: '#FFF5F0', hoverBg: '#FFE8DD', text: '#8B5A3D' },
    { bg: '#F0F8FF', hoverBg: '#DCF0FF', text: '#3D6B8B' },
    { bg: '#F5FFF0', hoverBg: '#E8FFDC', text: '#4A8B3D' },
    { bg: '#FFF0F5', hoverBg: '#FFDCE8', text: '#8B3D5A' },
  ];

  return (
    <div data-testid="field-tags-section" className="text-center">
      {title && <h2 className="text-[1.6rem] md:text-3xl lg:text-4xl text-[#00224F] mb-3" style={{ fontWeight: 750 }}>{title}</h2>}
      {description && <p className="text-[#5A6978] mb-10 max-w-2xl mx-auto text-sm md:text-base">{description}</p>}
      <div className="flex flex-wrap justify-center gap-3">
        {fields.map((field, index) => {
          const color = tagColors[index % tagColors.length];
          return (
            <a
              key={index}
              href={field.href}
              className="inline-flex items-center px-5 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 hover:shadow-md hover:-translate-y-0.5"
              style={{ backgroundColor: color.bg, color: color.text }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = color.hoverBg; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = color.bg; }}
              data-testid="field-tag"
            >
              {field.name}
            </a>
          );
        })}
      </div>
    </div>
  );
};
